<template>
	<div>
		<nav class="nav-tabs">
			<ul>
				<li :class="[activeTabName === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in tabs">
					<a @click.prevent="setActiveTabName(tab.name)" v-if="!tab.disabled"><i :class="tab.icon"></i> {{
						tab.displayName }}</a>
				</li>
			</ul>
		</nav>

		<div class="main">
			<div
					v-if="activeTabName === 'usersGeneral' && (userRoles.includes('provider_portal.users.update'))"
			>
				<header class="page-title">
					<h2>{{ editForm.name }}</h2>
					<div class="ml-auto">
						<a @click.prevent="deleteUser(editForm.id)" class="btn btn-mb btn-danger" href="#"
						   v-if="userRoles.includes('users.delete')"><i class="fas fa-trash"></i> Delete</a>
						<a @click.prevent="saveGeneral" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save
							Changes</a>
					</div>
				</header>


				<div class="flex box">
					<div class="eight-lg">
						<div class="card">
							<header class="card-header">
								<h3 class="card-title">General Information</h3>
							</header>
							<div class="card-body">
								<div class="flex box">
									<div class="nine">
										<div class="form-group">
											<label for="name">Name</label>
											<input class="input-large" id="name" required type="text"
												   v-model="editForm.name">
											<p class="input-error" v-if="errors.errors['name']">{{ errors.errors['name']
												}}</p>
										</div>
										<div class="form-group">
											<label for="email">Email Address</label>
											<input id="email" required type="email" v-model="editForm.email" value="">
											<p class="input-error" v-if="errors.errors['email']">{{
												errors.errors['email'] }}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<aside class="four-lg">
						<div class="card">
							<header class="card-header">
								<h3 class="card-title">Change Password</h3>
							</header>
							<div class="card-body">
								<form>
									<div class="form-group">
										<label for="new-pw">New Password</label>
										<input id="new-pw" type="password" v-model="newPass">
										<p class="input-error" v-if="errors.errors['password']">{{
											errors.errors['password'] }}</p>
									</div>
									<div class="form-group">
										<label for="new-pw-2">New Password Again</label>
										<input id="new-pw-2" type="password" v-model="newPassVerification">
									</div>
									<div class="text-center mt-2">
										<a @click="savePassword" class="btn btn-md btn-primary" href="#"><i
												class="fas fa-check"></i> Set New Password</a>
									</div>
								</form>
							</div>
						</div>
					</aside>
				</div>
			</div>

			<div
					v-if="activeTabName === 'usersProviders' && userRoles.includes('provider_portal.users.update')"
			>
				<header class="page-title">
					<h2>{{ editForm.name }}</h2>
					<div class="ml-auto">
					</div>
				</header>

				<div class="flex box">
					<div class="card six-lg eight-md twelve">
						<header class="card-header">
							<h3 class="card-title">Assign Provider</h3>
						</header>

						<div class="card-body">

							<div class="table-responsive mb-2">
								<table>
									<thead>
										<tr>
											<th width="0">Provider</th>
											<th class="actions" width="1">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="provider in assignedProviders">
											<td>{{ provider.name }}</td>
											<td class="actions">
												<button
														@click="removeProvider(provider)"
														class="btn btn-icon btn-danger"
														title="Delete"
												>
													<i class="fas fa-fw fa-spinner fa-spin"
													   v-if="removing === provider.id"></i>
													<i class="fas fa-fw fa-trash" v-else></i>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div class="flex box">
								<div class="form-group six mb-0">
									<label class="control-label sr-only" for="providerSelect">Select Provider</label>
									<vue-select
											:options="providers"
											inputId="providerSelect"
											label="name"
											name="providerSelect"
											placeholder="Select Provider"
											required
											v-model="selectedProvider"
									>
									</vue-select>
								</div>
								<button @click.prevent="addProvider()"
										class="btn btn-primary six" href="#"
								>
									<i class="fas fa-plus" v-if="!progress"></i>
									<i class="fas fa-spinner fa-spin" v-if="!!progress"></i> Add
								</button>

							</div>

						</div>
					</div>
				</div>


			</div>
		</div>
	</div>
</template>

<script>
	import Errors from "../../../Utils/Errors";
	import VueSelect from '../../../../../node_modules/vue-select';

	export default {
		components: {
			'vue-select': VueSelect
		},
		props: {
			dataEditForm: {
				type: Object
			},
			dataProviders: {
				type: Array
			},
			dataAssignedProviders: {
				type: Array
			}
		},
		data() {
			return {
				editForm: this.dataEditForm,
				providers: this.dataProviders,
				assignedProviders: this.dataAssignedProviders,
				currentUser: this.$currentUser,
				userRoles: this.$currentUserRoles,
				tabs: [
					{
						name: 'usersGeneral',
						displayName: 'General',
						icon: 'fas fa-user',
						disabled: false
					},
					{
						name: 'usersProviders',
						displayName: 'Providers',
						icon: 'fas fa-vcard',
						disabled: !this.$currentUserRoles.includes('provider_portal.users.update')
					}
				],
				activeTabName: null,
				errors: new Errors(),
				selectedProvider: undefined,
				newPass: '',
				newPassVerification: '',
				progress: false,
				removing: undefined
			}
		},
		mounted() {
			this.activeTabName = this.tabs[0].name;
		},
		methods: {
			setActiveTabName: function (name) {
				this.activeTabName = name;
			},
			saveGeneral: function () {
				axios.put('/api/' + this.$selectedSite.slug + '/providerPortalUsers/' + this.editForm.id, this.editForm)
					.then(response => {
						this.$toastr.success('User saved successfully', 'Success');
						window.location.reload();
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('User save failed.', 'Error');
					});
			},
			savePassword: function () {
				if (this.newPass.length <= 6) {
					this.errors.record({errors: {password: ['The given passwords are less then 6 characters!']}});
					this.$toastr.error('The given passwords are less then 6 characters!', 'Error');
					return;
				}

				if (this.newPass !== this.newPassVerification) {
					this.errors.record({errors: {password: ['The given passwords are not match!']}});
					this.$toastr.error('The given passwords are not match!', 'Error');
					return;
				}

				axios.post('/api/' + this.$selectedSite.slug + '/providerPortalUsers/' + this.editForm.id + '/savePassword', {password: this.newPass})
					.then(response => {
						this.$toastr.success('User password saved successfully', 'Success');
						window.location.reload();
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('User save failed.', 'Error');
					});
			},
			addProvider: function () {
				if (!this.selectedProvider) return;

				this.progress = true;
				axios.post('/api/' + this.$selectedSite.slug + '/providerPortalUsers/' + this.editForm.id + '/addProvider', {id: this.selectedProvider.id})
					.then(response => {
						this.$toastr.success('Provider assigned to portal user successfully', 'Success');
						this.assignedProviders.push(this.selectedProvider);
						this.selectedProvider = undefined;
						this.progress = false;
					})
					.catch(e => {
						this.progress = false;
						this.errors.record(e.response.data);
						this.$toastr.error('Provider assignment failed.', 'Error');
					});

			},
			removeProvider: function (provider) {
				if (this.removing === provider.id) return;
				this.removing = provider.id;
				axios.post('/api/' + this.$selectedSite.slug + '/providerPortalUsers/' + this.editForm.id + '/removeProvider', {id: provider.id})
					.then(response => {
						this.$toastr.success('Provider assigned to portal user successfully', 'Success');
						this.assignedProviders.splice(this.assignedProviders.findIndex(p => p.id = provider.id) - 1, 1);
						this.removing = undefined;
					})
					.catch(e => {
						this.removing = undefined;
						this.errors.record(e.response.data);
						this.$toastr.error('Provider assignment failed.', 'Error');
					});

			},
			deleteUser: function (id) {
				let vm = this,
					selectedSite = vm.$selectedSite.slug;

				vm.$dialog.confirm('Are you sure you want to delete this User?')
						.then((dialog) => {
							axios.delete('/api/' + selectedSite + '/providerPortalUsers/' + id)
									.then(response => {
										vm.$toastr.success('Delete successful.');
										setTimeout(function () {
											window.location.href = '/' + selectedSite + '/providerPortalUsers';
										}, 1000);
									})
									.catch(errors => {
										dialog.close();
										vm.$toastr.error('Delete failed.');
									});
						})
						.catch(error => {
							vm.$toastr.error('Delete aborted.');
						});
			}
		}
	}
</script>
<style scoped>
	.actions {
		text-align: center;
	}
</style>
